<template>
  <footer>
    <div class="container">
      <div class="footer-links">
        <a
          href="https://suportehotels.pmweb.com.br/pt/category/11"
          target="_blank"
        >
          Lets Conhecimento
        </a>
      </div>
      <IconLogoShort width="40px" />
    </div>
  </footer>
</template>

<script>
import IconLogoShort from '@/components/icons/IconLogoShort.vue';

export default {
  name: 'Footer',
  components: { IconLogoShort },
};
</script>

<style lang="scss" scoped>
footer {
  flex-shrink: 0;
  width: 100%;
  height: 45px;
  background: $lb-white;
  box-shadow: 10px 5px 10px 0 $lb-gray;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 16px;
  }

  a {
    color: $crm-blue-primary;
    font-weight: $lb-medium;
    padding: 4px 0;
  }
}
</style>
